module.exports = __webpack_public_path__ + "img/heatMap_selected.7cd88812.png";